export default __webpack_public_path__ + "static/media/FONDO_SORGO.eb9ab5cd.jpg";